import { jsx as _jsx } from "react/jsx-runtime";
import styles from './styles.module.css';
import { Bug } from "__barrel_optimize__?names=Bug!=!lucide-react";
import { cn } from "@/utils/theme/cn";
export default function ErrorComponent(param) {
    let { className } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: cn(styles.holder, className),
        children: /*#__PURE__*/ _jsx(Bug, {
            className: styles.icon
        })
    });
}
